import HudView from '../../View/HudView';
import DateUtils from '../../Utils/DateUtils';
import { COOLDOWNPRIZEWHEEL } from '../../UI/Map/PrizeWheelPopup';
import Core from '../../Core/Core';
import { Actions } from '../../State/Actions/Actions';
import AdTracking, { VideoAdReasons } from '../Tracking/AdTracking';
import { AdContexts, AdGameAreas, AdRewardTypes } from '../../DeltaTracking/AdParamBuilder';
import { getRandomReward } from '../../State/reducers/score';
import { ItemIDs, prizeWheelRewardItems } from '../../Config/Items';
import { HudActions, HudEmitter } from '../Hud/HudEmitter';
import { Popup, Popups } from '../Popups';

export class PrizeWheel {
    private view: HudView;
    private manager: Popups;
    private wheelAction: (args: string) => void;
    private closeAction: (layer: number, args: number) => void;

    constructor(view: HudView, parent: Popups) {
        this.view = view;
        this.manager = parent;

        this.wheelAction = (args: string) => {
            this.handlePrizeWheelAction(args);
        };

        this.closeAction = (layer: number, args: number) => {
            if (args === Popup.PRIZEWHEEL) {
                this.handlePopupClosed();
            }
        };
    }

    public addPrizeWheel() {
        const timeRemaining = DateUtils.timeRemainingTo(
            COOLDOWNPRIZEWHEEL + Core.store.getState().StatePlayer.prizeWheelCooldown
        );
        if (timeRemaining < 0) {
            Core.store.dispatch(Actions.setPriceWheelCooldown(0));
        }
        this.view.createPrizeWheelPopup(timeRemaining);

        HudEmitter.instance.on(HudActions.PRIZE_WHEEL_ACTION, this.wheelAction);

        HudEmitter.instance.on(HudActions.POPUP_CLOSED, this.closeAction);
    }

    private async handlePrizeWheelAction(s: string) {
        if (s === 'spin') {
            this.handleWheelSpin();
            Core.store.dispatch(Actions.setPriceWheelCooldown(Date.now()));
        } else if (s === 'watch') {
            if (Core.sdk.ads.getRewardedEnabled()) {
                this.manager.adSuccessAction = () => {
                    AdTracking.trackAdWatched(VideoAdReasons.PRIZE_WHEEL);
                    this.handleWheelSpin();
                };
                Core.delta.setAdParams(
                    AdRewardTypes.NONE,
                    AdContexts.MAP_WHEEL,
                    AdGameAreas.MAP,
                    -1
                );
                await this.manager.watchRewardedAd('wheel');
            }
        }
    }

    private handleWheelSpin() {
        const reward = getRandomReward(prizeWheelRewardItems);

        let index = 0;
        switch (reward.id) {
            case 'Heart':
                index = 0;
                break;
            case 'Coins':
                switch (reward.val) {
                    case 100:
                        index = 2;
                        break;
                    case 75:
                        index = 6;
                        break;
                    case 1000:
                        index = 3;
                        break;
                }
                break;
            case ItemIDs.FIRECRACKER:
                index = 1;
                break;
            case ItemIDs.MAGNET:
                index = 7;
                break;
            case ItemIDs.SHUFFLE:
                index = 5;
                break;
            case ItemIDs.HIGHLIGHT:
                index = 4;
                break;
        }
        this.view.prizeWheelPopup.spinWheel(index, reward);
        HudEmitter.instance.emit(HudActions.RECEIVE_REWARDS, [reward]);
    }

    private handlePopupClosed() {
        HudEmitter.instance.off(HudActions.PRIZE_WHEEL_ACTION, this.wheelAction);

        HudEmitter.instance.off(HudActions.POPUP_CLOSED, this.closeAction);
    }
}
